export enum EEnvs {
    dev = 'dev',
    devii = 'devii',
    qa = 'qat',
    uatii = 'uatii',
    prod = 'prod',
}

const currentEnv: EEnvs = (process.env.REACT_APP_ENV as EEnvs) ?? EEnvs.dev;

type TEnvAttrs = {
    REACT_APP_VERSION: string;
    REACT_APP_NAME: string;
    REACT_APP_ENV: EEnvs;
    REACT_APP_CHARTS_URL: string;
    REACT_APP_MSITE_URL: string;
    REACT_APP_APPLICATION_URL: string;
    REACT_APP_SUPPORT_URL: string;
    REACT_APP_COOKIE_DOMAIN: string;
    REACT_APP_API_URL: string;
    REACT_APP_MARKETING_HOSTING?: string;
    REACT_APP_STRIPE_PUBLISHABLE_KEY: string;
    REACT_APP_IS_MARKETING: boolean;
    awsconfig: Object;
};

type TEnvsMap = {
    [key in EEnvs]: TEnvAttrs;
};

const Envs: TEnvsMap = {
    [EEnvs.dev]: {
        REACT_APP_VERSION: currentEnv,
        REACT_APP_NAME: currentEnv,
        REACT_APP_IS_MARKETING: process.env.REACT_APP_IS_MARKETING === 'true',
        REACT_APP_ENV: currentEnv,
        REACT_APP_CHARTS_URL: 'https://ma-charts-dev.s3.us-east-1.amazonaws.com',
        REACT_APP_MSITE_URL: '',
        REACT_APP_APPLICATION_URL: 'https://dev.d12dvpsxvwz2ny.amplifyapp.com',
        REACT_APP_SUPPORT_URL: 'https://support.myadvocate.com/hc/en-us',
        REACT_APP_COOKIE_DOMAIN: 'dev.d12dvpsxvwz2ny.amplifyapp.com',
        REACT_APP_API_URL: 'https://ib8c8gkg89.execute-api.us-east-1.amazonaws.com/stage1',
        REACT_APP_MARKETING_HOSTING: undefined,
        REACT_APP_STRIPE_PUBLISHABLE_KEY:
            'pk_test_51HCnRALnq0KAJ6i6GaKmEfBec0Ia1sSzPOx6OJJmOeKk237mrypclLcxGZch7KbsZLbOlfeGNCefMaQftnQfZWHq0031vTaTo0',
        awsconfig: {
            aws_project_region: 'us-east-1',
            aws_cognito_region: 'us-east-1',
            aws_user_pools_id: 'us-east-1_WCXimQrcU',
            aws_user_pools_web_client_id: '4udbe3a5l5r6vrlddsjtqkcpt1',
            oauth: {
                domain: 'myadvocate-dev.auth.us-east-1.amazoncognito.com',
            },
            aws_cognito_username_attributes: [],
            aws_cognito_social_providers: [],
            aws_cognito_signup_attributes: [],
            aws_cognito_mfa_types: [],
            aws_cognito_password_protection_settings: {
                passwordPolicyCharacters: [],
            },
            aws_cognito_verification_mechanisms: [],
        },
    },
    [EEnvs.qa]: {
        REACT_APP_VERSION: process.env.REACT as string,
        REACT_APP_NAME: currentEnv,
        REACT_APP_IS_MARKETING: process.env.REACT_APP_IS_MARKETING === 'true',
        REACT_APP_ENV: currentEnv,
        REACT_APP_CHARTS_URL: 'https://ma-charts-qa.s3.us-east-1.amazonaws.com',
        REACT_APP_MSITE_URL: 'https://myadvocate.com',
        REACT_APP_APPLICATION_URL: 'https://qat.d12dvpsxvwz2ny.amplifyapp.com',
        REACT_APP_SUPPORT_URL: 'https://support.myadvocate.com/hc/en-us',
        REACT_APP_COOKIE_DOMAIN: 'qat.d12dvpsxvwz2ny.amplifyapp.com',
        REACT_APP_API_URL: 'https://tee31d1qv1.execute-api.us-east-1.amazonaws.com/stage1',
        REACT_APP_MARKETING_HOSTING: undefined,
        REACT_APP_STRIPE_PUBLISHABLE_KEY:
            'pk_test_51HCnRALnq0KAJ6i6GaKmEfBec0Ia1sSzPOx6OJJmOeKk237mrypclLcxGZch7KbsZLbOlfeGNCefMaQftnQfZWHq0031vTaTo0',
        awsconfig: {
            aws_project_region: 'us-east-1',
            aws_cognito_region: 'us-east-1',
            aws_user_pools_id: 'us-east-1_1lq8ta27t',
            aws_user_pools_web_client_id: '4qqf43rnluoisfpd94ggq9i7g6',
            oauth: {
                domain: 'myadvocate-qat.auth.us-east-1.amazoncognito.com',
            },
            aws_cognito_username_attributes: [],
            aws_cognito_social_providers: [],
            aws_cognito_signup_attributes: [],
            aws_cognito_mfa_types: [],
            aws_cognito_password_protection_settings: {
                passwordPolicyCharacters: [],
            },
            aws_cognito_verification_mechanisms: [],
        },
    },
    [EEnvs.uatii]: {
        REACT_APP_VERSION: process.env.REACT as string,
        REACT_APP_NAME: currentEnv,
        REACT_APP_IS_MARKETING: process.env.REACT_APP_IS_MARKETING === 'true',
        REACT_APP_ENV: currentEnv,
        REACT_APP_CHARTS_URL: 'https://ma-charts-uatii.s3.us-east-1.amazonaws.com',
        REACT_APP_MSITE_URL: 'https://myadvocateapp.com',
        REACT_APP_APPLICATION_URL: 'https://uatii.myadvocateapp.com',
        REACT_APP_SUPPORT_URL: 'https://support.myadvocate.com/hc/en-us',
        REACT_APP_COOKIE_DOMAIN: 'myadvocateapp.com',
        REACT_APP_API_URL: 'https://srxz13x7ue.execute-api.us-east-1.amazonaws.com/stage1',
        REACT_APP_MARKETING_HOSTING: 'https://muatii.d12dvpsxvwz2ny.amplifyapp.com/',
        REACT_APP_STRIPE_PUBLISHABLE_KEY:
            'pk_test_51HCnRALnq0KAJ6i6GaKmEfBec0Ia1sSzPOx6OJJmOeKk237mrypclLcxGZch7KbsZLbOlfeGNCefMaQftnQfZWHq0031vTaTo0',
        awsconfig: {
            aws_project_region: 'us-east-1',
            aws_cognito_region: 'us-east-1',
            aws_user_pools_id: 'us-east-1_DKvanGVJN',
            aws_user_pools_web_client_id: 'rbfim0madr01be8kgb4jssb54',
            oauth: {
                domain: 'myadvocate-uatii.auth.us-east-1.amazoncognito.com',
            },
            aws_cognito_username_attributes: [],
            aws_cognito_social_providers: [],
            aws_cognito_signup_attributes: [],
            aws_cognito_mfa_types: [],
            aws_cognito_password_protection_settings: {
                passwordPolicyCharacters: [],
            },
            aws_cognito_verification_mechanisms: [],
        },
    },
    [EEnvs.prod]: {
        REACT_APP_VERSION: process.env.REACT as string,
        REACT_APP_NAME: currentEnv,
        REACT_APP_IS_MARKETING: process.env.REACT_APP_IS_MARKETING === 'true',
        REACT_APP_ENV: currentEnv,
        REACT_APP_CHARTS_URL: 'https://diagram.myadvocate.com',
        REACT_APP_MSITE_URL: 'https://myadvocate.com',
        REACT_APP_APPLICATION_URL: 'https://app.myadvocate.com',
        REACT_APP_SUPPORT_URL: 'https://support.myadvocate.com/hc/en-us',
        REACT_APP_COOKIE_DOMAIN: 'myadvocate.com',
        REACT_APP_API_URL: 'https://i5mfgzwsy8.execute-api.us-east-1.amazonaws.com/stage1',
        REACT_APP_MARKETING_HOSTING: 'https://mprod.d12dvpsxvwz2ny.amplifyapp.com/',
        REACT_APP_STRIPE_PUBLISHABLE_KEY:
            'pk_live_51HCnRALnq0KAJ6i6m6UeikEjxlQXTKPF6vg6CyPZNIm8ynTvPY38EVCU9CqPwNEn3rP1DxwWJiby87kOjn8UMnbh00lkyD4Y7L',
        awsconfig: {
            aws_project_region: 'us-east-1',
            aws_cognito_region: 'us-east-1',
            aws_user_pools_id: 'us-east-1_bfFQVCffL',
            aws_user_pools_web_client_id: '7nudp9tckcmo1dhu2bcrrmtt8r',
            oauth: {
                domain: 'myadvocate-prod.auth.us-east-1.amazoncognito.com',
            },
            aws_cognito_username_attributes: [],
            aws_cognito_social_providers: [],
            aws_cognito_signup_attributes: [],
            aws_cognito_mfa_types: [],
            aws_cognito_password_protection_settings: {
                passwordPolicyCharacters: [],
            },
            aws_cognito_verification_mechanisms: [],
        },
    },
    [EEnvs.devii]: {
        REACT_APP_VERSION: currentEnv,
        REACT_APP_NAME: currentEnv,
        REACT_APP_IS_MARKETING: process.env.REACT_APP_IS_MARKETING === 'true',
        REACT_APP_ENV: currentEnv,
        REACT_APP_CHARTS_URL: 'https://ma-charts-dev.s3.us-east-1.amazonaws.com',
        REACT_APP_MSITE_URL: 'https://myadvocate.com',
        REACT_APP_APPLICATION_URL: 'https://devii.d12dvpsxvwz2ny.amplifyapp.com',
        REACT_APP_SUPPORT_URL: '',
        REACT_APP_COOKIE_DOMAIN: '',
        REACT_APP_API_URL: 'https://51j84wmz4m.execute-api.us-east-1.amazonaws.com/stage1',
        REACT_APP_MARKETING_HOSTING: undefined,
        REACT_APP_STRIPE_PUBLISHABLE_KEY:
            'pk_test_51HCnRALnq0KAJ6i6GaKmEfBec0Ia1sSzPOx6OJJmOeKk237mrypclLcxGZch7KbsZLbOlfeGNCefMaQftnQfZWHq0031vTaTo0',
        awsconfig: {
            aws_project_region: 'us-east-1',
            aws_cognito_region: 'us-east-1',
            aws_user_pools_id: 'us-east-1_1BUATf5xa',
            aws_user_pools_web_client_id: '5ch6ld3in30v9jqdabaiqk7e4l',
            oauth: {},
            aws_cognito_username_attributes: [],
            aws_cognito_social_providers: [],
            aws_cognito_signup_attributes: [],
            aws_cognito_mfa_types: [],
            aws_cognito_password_protection_settings: {
                passwordPolicyCharacters: [],
            },
            aws_cognito_verification_mechanisms: [],
        },
    },
};

export default Envs[currentEnv];
